package com.rainbowclubs.rainbow.domain.use_cases.home

import com.rainbowclubs.rainbow.data.models.HomeResponse
import com.rainbowclubs.rainbow.domain.repositories.HomeRepository

class GetHomeDataUseCase(
    private val homeRepository: HomeRepository,
) {
    suspend operator fun invoke(clubId: String): Result<HomeResponse> {
        return homeRepository.getHomeData(clubId)
    }
}
